/* 
Uses functions and variables from asset files
- 'size-guide-functions.js'
*/
function loadSizeTablesPDP(brand) {
    let atLeastOneSizeChart = false;
    let sizeGuidePagesURL = {
        mens: `/pages/${brand}-size-guide-mens?view=blank`,
        womens: `/pages/${brand}-size-guide-womens?view=blank`,
        unisex: `/pages/${brand}-size-guide-unisex?view=blank`,
        kids: `/pages/${brand}-size-guide-kids?view=blank`,
    };

    Promise.all([fetch(sizeGuidePagesURL.mens), fetch(sizeGuidePagesURL.womens), fetch(sizeGuidePagesURL.unisex), fetch(sizeGuidePagesURL.kids)]) //Ajax call to get all the size pages.
        .then(function (responses) {
            return Promise.all(
                responses.map(function (response) {
                    if (response.ok) {
                        atLeastOneSizeChart = true;
                        return response.text();
                    }
                })
            );
        })
        .then((response) => {
            if (atLeastOneSizeChart) {
                showSizeguideModalButton();
            }

            response.forEach(function (data, index) {
                try {
                    parseAndAppendTable(data, __sizeGuideContainersId[index], false);
                } catch {
                    console.log(`${__sizeGuideContainersId[index]} for ${brand} is unavailable.`);
                }
            });

            return;
        });
}

// Run functions 
if (typeof __productPdp !== "undefined" && __productPdp.vendor !== '' && __productPdp.isAccessory == 'false') {
    triggerCollapsibleTables();//Fnc in size-guide-functions.js
    loadSizeTablesPDP(__productPdp.vendor);
}